import axios from 'axios';

const errorResponseHandler = (error) => {
    if (!error.response) return console.error(error);

    if (
        Object.prototype.hasOwnProperty.call(error.config, 'errorHandle')
        && error.config.errorHandle === false
    ) {
        return Promise.reject(error);
    }

    const {
        response: {
            data: {
                message,
            },
            status,
        },
    } = error;

    if (message) window.Feedback.feedbackLoad({ closeable: true, message });
    if (status === 404) window.Feedback.feedbackLoad({ closeable: true, message: 'Something went wrong.' });

    if (error || message || status === 404) {
        return Promise.reject(error || message);
    }

    return false;
};

axios.interceptors.response.use(
    response => response,
    errorResponseHandler,
);

export default {
    init() {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
};
